@let linkUrl = url;
@let label = displayText || ('LINK_TO_FIELD' | translate);

@if (linkUrl) {
  <a class="field-passport-link" [href]="linkUrl" target="_blank" rel="noopener noreferrer">{{ label }}</a>
} @else {
  <span class="field-passport-link__plain">—</span>
}
